import { styled } from "@mui/material";
import { simulateClickOnEle } from "@smartrr/shared/utils/simulateActions";
import { Cross } from "akar-icons";
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Slide, ToastContainer } from "react-toastify";

export const StyledContainer = styled(ToastContainer)<{ isMobile: boolean }>`
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  margin-bottom: ${props => (props.isMobile ? "55px" : "inherit")};
  width: 100% !important;

  .Toastify__toast--error {
    background-color: #c61e00 !important;
  }
  .Toastify__toast {
    align-items: center;
    background-color: #202223;
    border-radius: 8px;
    color: #f4f4f4;
    min-height: 60px;
    padding: 20px;
    width: max-content !important;
  }
  // TODO: Change font to theming values
  .Toastify__toast-body {
    font-family: ${props => props.theme.modernBodyFontFamily} !important;
    line-height: 20px;
    padding: 0 20px 0 0;
  }
  .Toastify__close-button--default {
    color: #f4f4f4;
    opacity: 1;
  }

  * {
    text-align: center;
  }
`;

export const StyledToast = ({ isMobile = false }: { isMobile?: boolean }) => {
  const ref = useRef<HTMLDivElement>(null);
  const toastQuery = ".Toastify__toast";

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const toastEle = ref.current?.querySelector(toastQuery);
      if (toastEle) {
        // First delay is needed for toast to render
        const waiting = setTimeout(() => {
          // Second delay is needed for toast to appear for desired amount of time before being closed
          const timer = setTimeout(() => {
            simulateClickOnEle(ref, toastQuery);
          }, 3000);
          return () => {
            clearTimeout(timer);
          };
        }, 1000);
        return () => {
          clearTimeout(waiting);
        };
      }
    });

    if (ref.current) {
      observer.observe(ref.current, { childList: true, subtree: true });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <React.Fragment>
      {createPortal(
        <div id="smartrr_toast_container" ref={ref}>
          <StyledContainer
            isMobile={isMobile}
            position="bottom-center"
            transition={Slide}
            // autoClose={20000} autoClose through react-toastify doesn't work so we're manually closing the toast above
            hideProgressBar
            newestOnTop={true}
            limit={1}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            closeButton={<Cross strokeWidth={2} size={14} />}
            draggable
            pauseOnHover
          />
        </div>,
        document.body
      )}
    </React.Fragment>
  );
};
